import * as React from 'react';
import * as ReactDOM from 'react-dom';
import SpsIntercom from '../../../react/SpsIntercom';

export class SpsIntercomRootController {
    public static $inject = [];

    constructor() {
        if (document.getElementById('sps-intercom-root')) {
            ReactDOM.render(
                React.createElement(SpsIntercom),
                document.getElementById('sps-intercom-root')
            );
        }
    }
}
